import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ordersApi, type Order } from '../../api/orders';

export function OrderListPage() {
  const [orders, setOrders] = useState<Order[]>([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState<string | null>(null);

  function load() {
    void ordersApi.list().then(setOrders).catch((e) => setError(String(e)));
  }

  useEffect(() => { load(); }, []);

  async function action(id: string, fn: () => Promise<unknown>) {
    setBusy(id);
    try {
      await fn();
      load();
    } catch (e) {
      setError(String(e));
    } finally {
      setBusy(null);
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Orders</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="border-b text-left">
              <th className="p-2">Order #</th>
              <th className="p-2">Source</th>
              <th className="p-2">Status</th>
              <th className="p-2">Amount</th>
              <th className="p-2">Health</th>
              <th className="p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b">
                <td className="p-2"><Link to={`/orders/${o.id}`} className="text-blue-600 hover:underline">{o.order_number}</Link></td>
                <td className="p-2">{o.source}</td>
                <td className="p-2">{o.status}</td>
                <td className="p-2">{o.currency} {o.total_amount.toFixed(2)}</td>
                <td className="p-2">{o.health_score}</td>
                <td className="p-2 space-x-2">
                  <button type="button" disabled={busy === o.id} className="text-blue-600 hover:underline" onClick={() => void action(o.id, () => ordersApi.allocate(o.id))}>Allocate</button>
                  <button type="button" disabled={busy === o.id} className="text-blue-600 hover:underline" onClick={() => void action(o.id, () => ordersApi.hold(o.id))}>Hold</button>
                  <button type="button" disabled={busy === o.id} className="text-red-600 hover:underline" onClick={() => void action(o.id, () => ordersApi.cancel(o.id))}>Cancel</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
